var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sip-empty",
      class: "sip-empty--" + _vm.size,
      attrs: { role: "status" },
    },
    [
      _c(
        "div",
        { staticClass: "sip-empty__well", attrs: { "aria-hidden": "true" } },
        [_c("admin-icon", { attrs: { name: _vm.icon, size: _vm.iconPx } })],
        1
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "sip-empty__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _vm.hintText
        ? _c("p", { staticClass: "sip-empty__hint" }, [
            _vm._v(_vm._s(_vm.hintText)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAction
        ? _c(
            "div",
            { staticClass: "sip-empty__action" },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }